function MissingIdTokenError() {
  this.name = 'MissingIdTokenError'
  this.message = 'Id token not found'
  this.stack = new Error().stack
}
MissingIdTokenError.prototype = Object.create(Error.prototype)
MissingIdTokenError.prototype.constructor = MissingIdTokenError

export { MissingIdTokenError }
